import { z } from "zod";

import { dashboardMetricsMatchers } from "./_dashboard-metrics-matchers";
import { dashboardVariableLabelName } from "./_dashboard-variable-label-name";

export const dashboardMetricLabelValuesVariableSchema = z.object({
	labelName: dashboardVariableLabelName,
	matchers: dashboardMetricsMatchers,
});

export type DashboardMetricLabelValuesVariable = z.infer<typeof dashboardMetricLabelValuesVariableSchema>;
